module.exports = __webpack_public_path__ + "img/springroll_folded.d1f99398.jpg";